
class PaymentInstallmentTemplateListViewController extends MUIViewController
{
    static newInstance() : PaymentInstallmentTemplateListViewController {
        let vc = new PaymentInstallmentTemplateListViewController("payment-installment-template-list-view");
        vc.initWithResource("layout/installment_templates/PaymentInstallmentTemplateListView.html");
        return vc;
    }

    private addButton:MUIButton = null;
    private tableView:UITableView = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setAction(this, this.addTemplate);

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false) return;

        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    numberOfSections(tableview:UITableView){
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableview:UITableView, section:number){
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let cell = tableview.dequeueReusableCellWithIdentifier("PaymentInstallmentTemplateCell") as PaymentInstallmentTemplateCell;

        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as PaymentInstallmentTemplate;
        cell.item = item;

        return cell;
    }

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as PaymentInstallmentTemplate;

        let vc = PaymentInstallmentTemplateDetailViewController.newInstance();
        vc.item = item;

        this.navigationController.pushViewController(vc, true);
    }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView:UITableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as PaymentInstallmentTemplate;

        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            DBHelper.deleteObjectFromMainContext(item, true);
        }
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;

        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("name", true)];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("PaymentInstallmentTemplate", sortDescriptors, null);

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;

        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller:MIOFetchedResultsController){
        this.tableView.reloadData();
    }

    private addTemplate(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("NEW_PAYMENT_TEMPLATE", "NEW PAYMENT TEMPLATE"), MIOLocalizeString("NAME_PAYMENTS_AND_DAYS_BETWEEN_THEM", "NAME, NUMBER OF PAYMENTS AND DAYS BETWEEN THEM"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("NAME", "NAME"));
        });

        avc.addComboBoxWithConfigurationHandler(this, function(comboBox:MUIComboBox){
            for (let i = 1; i <= 12; i++) comboBox.addItem(i + " " + MIOLocalizeString("PAYMENTS", "PAYMENTS"), i);
            comboBox.selectItem(2);
        });

        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("DAYS_BETWEEN_PAYMENTS", "DAYS BETWEEN PAYMENTS"));
            textField.text = "30";
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("ADD", "ADD"), MUIAlertActionStyle.Default, this, function(this:PaymentInstallmentTemplateListViewController){
            let name = avc.textFields[0].text.trim();
            if (name.length == 0) return;

            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            let count = parseInt(avc.comboBoxes[0].getSelectedItem());
            if (isNaN(count) || count < 1) count = 1;

            let days = ad.numberFormatter.numberFromString(avc.textFields[1].text.trim());
            if (days == null || days < 0) days = 0;

            this.createTemplate(name, count, days);
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }

    // "2 payments every 30 days" -> lines at 30 and 60 days, 50% each. The user can then
    // tweak the percentages, the days or add more lines in the detail view.
    private createTemplate(name:string, count:number, days:number){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        let template = MIOEntityDescription.insertNewObjectForEntityForName("PaymentInstallmentTemplate", ad.managedObjectContext) as PaymentInstallmentTemplate;
        template.name = name;
        template.numberOfPayments = count;
        template.expirationInterval = days.toString();

        let percentage = Math.floor((100 / count) * 100) / 100;
        for (let i = 0; i < count; i++) {
            let line = MIOEntityDescription.insertNewObjectForEntityForName("PaymentInstallmentTemplateLine", ad.managedObjectContext) as PaymentInstallmentTemplateLine;
            line.orderIndex = i + 1;
            line.offsetDays = days * (i + 1);
            line.percentage = (i == count - 1) ? Math.round((100 - percentage * (count - 1)) * 100) / 100 : percentage;
            line.template = template;
        }

        ad.managedObjectContext.save();

        let vc = PaymentInstallmentTemplateDetailViewController.newInstance();
        vc.item = template;
        this.navigationController.pushViewController(vc, true);
    }
}
